<template>
  <INFO></INFO>
</template>

<script>
import INFO from "place/drawactivity/info.vue";
export default {
  components: {
    INFO,
  },
};
</script>
